<!-- display-mobile-02 preview — full-screen image grid ad -->
<app-mobile-frame>
  <div class="gs-page">
    <div class="gs-grid d-flex flex-row">
      <div
        *ngFor="let column of [leftTiles, rightTiles]"
        class="gs-column d-flex flex-column"
      >
        <a
          *ngFor="let tile of column"
          class="gs-tile"
          [href]="data.url || null"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="gs-tile-image" [style.height.rem]="tile.height">
            <img [src]="tile.image" alt="" />
          </span>
          <span class="gs-tile-title">{{ tile.title }}</span>
        </a>
      </div>
    </div>

    <!-- Ad choices and skip icons -->
    <i class="bi bi-info-circle gs-info"></i>
    <span class="gs-skip"><i class="bi bi-skip-end-fill"></i></span>

    <!-- START: Brand bar -->
    <a
      class="gs-brand-bar d-flex flex-row align-items-center"
      [href]="data.url || null"
      target="_blank"
      rel="noopener noreferrer"
    >
      <span class="gs-logo"><img src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png" alt="" /></span>
      <span class="gs-brand-info d-flex flex-column">
        <span class="gs-long-headline">{{ longHeadline }}</span>
        <span class="gs-brand-name">Valamar</span>
      </span>
      <i class="bi bi-chevron-right gs-chevron"></i>
    </a>
    <!-- END: Brand bar -->
  </div>
</app-mobile-frame>
